function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { node, oneOf } from 'prop-types';
import { Text } from './../../Text/Text';
import { PARAMS } from './textHeadingData';

var TextHeading = function TextHeading(_ref) {
  var h = _ref.h,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["h", "children"]);

  return React.createElement(Text, _objectSpread({}, PARAMS[h], props), children);
};

TextHeading.type = PARAMS;
TextHeading.propTypes = {
  h:
  /*#__PURE__*/
  oneOf(
  /*#__PURE__*/
  Object.keys(PARAMS)),
  children: node
};
TextHeading.defaultProps = {
  h: 'h1'
};
TextHeading.displayName = 'Text.Heading';
export { TextHeading };